import React, { memo } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../../../../../store/root-reducer';
import SelectNumbersStep from './select-numbers-step';
import { PhoneNumberCartItem, PhoneNumberData } from '../../../../../../types/phone-numbers';
import { getIsRequestPending } from '../../../../../../../../shared/utils/get-request-status';
import { RequestStatus } from '../../../../../../../../shared/enums/request-status';

export interface Iprops {
  onToggleNumberSelection: (phoneNumber: string) => void;
  formattedPhoneNumbersData: PhoneNumberData[];
  freeNumbersQuota: number;
}

const SelectNumbersStepContainer = memo(
  (props: Iprops) => {
    const phoneNumbersInCart = useSelector(
      (state: RootState) => state.dialer.phoneNumbersInCart,
    );
    const searchPhoneNumbersRequestStatus = useSelector(
      (state: RootState) => state.dialer.searchPhoneNumbersRequest.status,
    );
    const addPhoneNumbersToCartRequest = useSelector(
      (state: RootState) => state.dialer.addPhoneNumbersToCartRequest,
    );
    const removePhoneNumberFromCartRequest = useSelector(
      (state: RootState) => state.dialer.removePhoneNumberFromCartRequest,
    );
    const isSearching = getIsRequestPending(searchPhoneNumbersRequestStatus);
    

    return (
      <SelectNumbersStep
        {...props}
        isSearching={isSearching}
        phoneNumbersInCart={phoneNumbersInCart}
        addPhoneNumbersToCartRequest={addPhoneNumbersToCartRequest}
        removePhoneNumberFromCartRequest={removePhoneNumberFromCartRequest}
      />
    );
  },
);

export type SelectNumbersStepProps = Iprops & {
    phoneNumbersInCart: PhoneNumberCartItem[];
    isSearching: boolean;
    addPhoneNumbersToCartRequest: {
      [phoneNumber: string]: {
        status: RequestStatus;
        message: string;
        error: any;
      };
    };
    removePhoneNumberFromCartRequest: {
      [phoneNumber: string]: {
        status: RequestStatus;
        message: string;
        error: any;
      };
    };
    freeNumbersQuota: number;
};
SelectNumbersStepContainer.displayName = 'SelectNumbersStepContainer';

export default SelectNumbersStepContainer;

